import React from 'react';
// Custom Components
import { ModalConfirmButton, ModalCloseButton } from '../Buttons';
// Material components
import DialogActions from '@material-ui/core/DialogActions';
// Styles
import { flex } from '../../assets/jss';

export default function ModalFooter(props) {
    const { handleSubmit, handleOpen } = props;

    return (
        <DialogActions style={flex.flex_row_around}>
            <ModalConfirmButton onClick={handleSubmit} />
            <ModalCloseButton onClick={handleOpen} />
        </DialogActions>
    );
}